<template>
  <div class="marking">
    <div class="banner">
      <img src="../../assets/cxlyxglrj_banner.png" alt="">
    </div>
    <div class="section_w target" style="padding-bottom: 0px">
      <div class="container">
        <div class="section_title left">
          <p>
            SCRM系统的核心目标
          </p>
          <aside>
            Core target
          </aside>
        </div>
        <div class="target_big">
          <img src="../../assets/marking_target.png" alt="">
          <div class="text_w">
            <p class="t1">大数据系统分析消费者行为及特征，定制个性化营销和服务方案，构建品牌忠诚度体系；分级转化，逐步渗透，多维度分析管理，精准定位客户人群特征，驱动运营决策；</p>
            <p class="t2">通过社交渠道，开启更关注用户体验的个性化服务，将顾客价值最大化维护老客户，培养新客户，激活沉默客户，让卖家转粉，实现会员互动；</p>
            <p class="t3">
              购物返利、试用、上新等活动配合店铺二次营销引导老客流量与复购，提升产品销售；
            </p>
            <p class="t4">通过SCRM系统，提升导购、加盟店推广品牌会员积极性及服务能力，提升公众品牌认可度，品牌直接连接用户，有效提升品牌价值；</p>
          </div>
        </div>
        <div class="target_small row">
          <div class="col-sm-6 col-xs-12">
            <img src="../../assets/target_icon01.png" alt="">
            <p>
              大数据系统分析消费者行为及特征，定制个性化营销和服务方案，构建品牌忠诚度体系；分级转化，逐步渗透，多维度分析管理，精准定位客户人群特征，驱动运营决策；
            </p>
          </div>
          <div class="col-sm-6 col-xs-12">
            <img src="../../assets/target_icon02.png" alt="">
            <p>
              通过社交渠道，开启更关注用户体验的个性化服务，将顾客价值最大化维护老客户，培养新客户，激活沉默客户，让卖家转粉，实现会员互动；
            </p>
          </div>
          <div class="col-sm-6 col-xs-12">
            <img src="../../assets/target_icon03.png" alt="">
            <p>
              购物返利、试用、上新等活动配合店铺二次营销引导老客流量与复购，提升产品销售；
            </p>
          </div>
          <div class="col-sm-6 col-xs-12">
            <img src="../../assets/target_icon04.png" alt="">
            <p>
              通过SCRM系统，提升导购、加盟店推广品牌会员积极性及服务能力，提升公众品牌认可度，品牌直接连接用户，有效提升品牌价值；
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w power" style="padding-bottom: 0px">
      <div class="container">
        <div class="section_title right">
          <p>
            核心能力
          </p>
          <aside>
            Core competence
          </aside>
        </div>

      </div>
      <div class="power_w">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-sm-6 col-xs-12">
              <div class="text-w">
                <h4>
                  前端服务
                </h4>
                <p>
                  打造适合用户习惯的公众号平台灵活易用的沟通平台
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6 col-xs-12">
              <div class="text-w">
                <h4>
                  运营
                  管理
                </h4>
                <p>
                  多维度的用户服务流程
                  多维度的营销互动平台
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6 col-xs-12">
              <div class="text-w">
                <h4>
                  数据
                  服务
                </h4>
                <p>
                  用户画像、用户习惯据人群标签、数据分析
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w function" style="padding-bottom: 0px">
      <div class="container">
        <div class="section_title left">
          <p>
            整体功能介绍
          </p>
          <aside>
            Overall function
          </aside>
        </div>
        <div class="position_r">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="../../assets/function_content01.png" alt="">
              </div>
              <div class="swiper-slide">
                <img src="../../assets/function_content02.png" alt="">
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
    </div>
    <div class="section_w market">
      <div class="container">
        <div class="row">
          <div class="col-sm-4 col-xs-12">
            <img src="../../assets/Marketing_case_pic01.png" alt="">
          </div>
          <div class="col-sm-4 col-xs-12">
            <img src="../../assets/Marketing_case_pic02.png" alt="">
          </div>
          <div class="col-sm-4 col-xs-12">
            <img src="../../assets/Marketing_case_pic03.png" alt="">
          </div>
          <div class="col-sm-4 col-xs-12">
            <img src="../../assets/Marketing_case_pic04.png" alt="">
          </div>
          <div class="col-sm-4 col-xs-12">
            <img src="../../assets/Marketing_case_pic06.png" alt="">
          </div>
          <div class="col-sm-4 col-xs-12">
            <img src="../../assets/Marketing_case_pic06.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="section_w " style="padding-bottom: 0px">
      <div class="container">
        <div class="section_title right">
          <p>
            客户受益
          </p>
          <aside>
            Customer revenue
          </aside>
        </div>
      </div>
      <div class="profit">
        <div class="profit-big container">
          <div class="p1">
            <h5>规划的方向性</h5>
            <p>对品牌规划、品牌大方向走势和目标提供了指导意义。</p>
          </div>
          <div class="p2">
            <h5>数据的统一性</h5>
            <p>通过接口将淘宝、天猫等各个店铺的数据进行整合汇总，从而提高了数据的分析能力。</p>
          </div>
          <div class="p3">
            <h5>客户服务的直接性</h5>
            <p>通过微信公众号与客户建立直接的关联，实时有效的与客户沟通，提高了沟通效率和客户认可度。</p>
          </div>
          <div class="p4">
            <h5>运营拓展活动的指导性</h5>
            <p>通过与客户沟通对数据分析后，给运营人员在线下拓展活动有了更明确的指导意义。提高了拓展活动的效益，推进了品牌的可认知度和广泛度。使得拓展活动带来更好更大的收益。</p>
          </div>
        </div>
        <div class="profit-small container">
          <div class="col-sm-6 col-xs-12">
            <h5>规划的方向性</h5>
            <p>对品牌规划、品牌大方向走势和目标提供了指导意义。</p>
          </div>
          <div class="col-sm-6 col-xs-12">
            <h5>数据的统一性</h5>
            <p>通过接口将淘宝、天猫等各个店铺的数据进行整合汇总，从而提高了数据的分析能力。</p>
          </div>
          <div class="col-sm-6 col-xs-12">
            <h5>客户服务的直接性</h5>
            <p>通过微信公众号与客户建立直接的关联，实时有效的与客户沟通，提高了沟通效率和客户认可度。</p>
          </div>
          <div class="col-sm-6 col-xs-12">
            <h5>运营拓展活动的指导性</h5>
            <p>通过与客户沟通对数据分析后，给运营人员在线下拓展活动有了更明确的指导意义。提高了拓展活动的效益，推进了品牌的可认知度和广泛度。使得拓展活动带来更好更大的收益。</p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
  import Swiper from 'swiper'
  import Footer from '../../components/Footer'

  export default {
    components: {
      Footer
    },
    mounted() {
      new Swiper('.swiper-container', {
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
    },
    props: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner img {
    width: 100%
  }

  .target {
    background: url("../../assets/target_bg.jpg") no-repeat center;
    background-size: 100% 100%;
  }

  .target_big {
    position: relative;
    padding: 22.4% 0;
  }

  .target_big img {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
  }

  .target_big .text_w {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
  }

  .text_w p {
    font-size: 1.8rem;
    color: #666666;
    position: absolute;
    width: 27%;
  }

  .text_w .t1 {
    left: 14%;
    top: 9%;
  }

  .text_w .t2 {
    left: 36%;
    bottom: 5%;
  }

  .text_w .t3 {
    right: 6%;
    top: 11%;
  }

  .text_w .t4 {
    right: 2%;
    bottom: 17%;
  }

  .target_small {
    text-align: center;
  }

  .target_small p {
    text-align: left;
    font-size: 1.8rem;
    color: #666666;
    margin: 15px 0px 15px;
  }

  .power .row h4 {
    color: #b2670e;
    border-left: 6px solid #b2670e;
    padding: 9px 0px 9px 13px;
    font-size: 24px;
    width: 75px;
    display: inline-block;
  }

  .power .row p {
    color: #fff;
    background: #b2670e;
    font-size: 18px;
    width: 256px;
    display: inline-block;
    float: right;
    padding: 20px;
  }

  .power .row .text-w {
    border: 1px solid #b2670e;
    padding: 60px 0px;
    margin-bottom: 30px;
  }

  .power_w {
    background: url("../../assets/customer_bg.jpg") no-repeat center;
    background-size: 100% 100%;
    padding: 60px 0px 30px;
  }

  .function img {
    width: 100%;
    height: 100%;
  }
  .function {
    background: url("../../assets/function_bg.jpg") no-repeat center;
    background-size: 100% 100%;
  }
  .market {
    background: url("../../assets/Marketing_case_bg.jpg") no-repeat center;
    background-size: 100% 100%;
  }
  .profit {
    background: url("../../assets/customer_bg.jpg") no-repeat center;
    background-size: 100% 100%;
  }
  .market .row >div {
    margin-bottom: 30px;

  }
  .market .row >div img {
    width: 100%;
  }
  .profit-big {
    height: 550px;
    background: url("../../assets/customer_content.png") no-repeat center bottom;
    position: relative;
  }
  .profit h5  {
    color: #b2670e;
    font-size: 2.4rem;
    font-weight: bold;
  }
  .profit p  {
    color: #b2670e;
    font-size: 1.8rem;
    font-weight: normal;
  }
  .profit-big >div {
    position: absolute;
    width: 20%;
  }
  .profit-big .p1 {
    top: 53%;
    left: 0%;
  }
  .profit-big .p2 {
    top: 20%;
    left: 7%;
  }
  .profit-big .p3 {
    top: 20%;
    right: 3%;
  }
  .profit-big .p4 {
    top: 53%;
    right: -1%;
    width: 23%;
  }
  .profit-small {
    padding: 40px 0px;
  }
  .profit-small h5 {
    text-align: center;
    margin-bottom: 20px;
  }
  .profit-small p {
    margin-bottom: 30px;
  }
  @media (max-width: 991px) and (min-width: 769px) {
    .target_small p {
      min-height: 100px;
    }

  }

  @media (max-width: 991px) {

    .target_big {
      display: none;
    }
    .profit-big {
      display: none;
    }
  }

  @media (min-width: 992px) {
    .target_small {
      display: none;
    }
    .profit-small {
      display: none;
    }

  }
</style>
